const circularProgress = {
  MuiCircularProgress: {
    defaultProps: {
      thickness: 2.5,
    },
  },
}

export default circularProgress
